import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from './../base/base.component';

@Component({
  selector: 'app-header-toolbar',
  templateUrl: './header-toolbar.component.html',
  styleUrls: ['./header-toolbar.component.scss']
})
export class HeaderToolbarComponent extends BaseComponent implements OnInit {

  currIndex: number;

  @Input() adminClientId: string;

  @Input() toolbarText: Array<string>;

  @Input() selectedIndex: number;

  @Output() clicked: EventEmitter<object> = new EventEmitter();

  @Output() selectedTabChanged: EventEmitter<any> = new EventEmitter();

  constructor(ele: ElementRef) {
    super(ele);
    this.selectedIndex = -1;
    this.currIndex = 0;
  }

  onClick(num: number) {
    // remove this condition for including report
    if(this.selectedIndex==0)
      this.selectedIndex=num;
    this.selectedIndex = num + 1;
    this.clicked.emit({ index: this.selectedIndex, event: 'selected' });
    this.selectedTabChanged.emit();
  }

  ngOnInit() {
    if (this.adminClientId !== '0') {
      let indexOfSuperAdmin: number;
      this.toolbarText.forEach((item, index) => {
        if (item === 'Super Admin') {
          indexOfSuperAdmin = index;
          return;
        }
      });

      if (indexOfSuperAdmin) {
        this.toolbarText.splice(indexOfSuperAdmin, 1);
      }

    }
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/header-toolbar/header-toolbar.component.ts